import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import {
  Box,
} from '@mui/material';
import GradientCircularLoader from '../../molecula/circularLoader/circularLoader';

export default function Modal({open, handleClose, dataShow, title, actions, loader, size, sx}) {


  return (
    <Dialog
      onClose={() => handleClose()}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth
      maxWidth={size}
      sx={sx}
      
    >
      <DialogTitle sx={{ m: 0, p: 2, textAlign:'center', pl:5, pr:5 }} id="customized-dialog-title">
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => handleClose()}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers sx={{position:'relative'}}>
      {loader  && <Box sx={{ backgroundColor: '#ffffff99', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, zIndex: 100, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><GradientCircularLoader /></Box>}
        {dataShow}
      </DialogContent>
      <DialogActions>
        {actions}
      </DialogActions>
    </Dialog>
  );
}